import React from "react";
import { Button } from "@headlessui/react";
import CustomPopover from "../CustomDialog/CustomPopover";
export default function ConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonVariant = "primary",
}) {
  const baseButtonClasses = "px-4 py-2 text-sm font-medium rounded-md";

  let confirmClasses = `${baseButtonClasses}`;
  if (confirmButtonVariant === "error") {
    confirmClasses += ` bg-red-600 text-white hover:bg-red-700`;
  } else {
    confirmClasses += ` bg-blue-600 text-white hover:bg-blue-700`;
  }

  const cancelClasses = `${baseButtonClasses} text-gray-700 dark:text-gray-300 ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-gray-200`;

  return (
    <CustomPopover
      isOpen={isOpen}
      onClose={onClose}
      headerText={title}
      panelClassName="max-w-md"
    >
      {/* Content div for message */}
      <div className="mt-4">
        <p className="text-sm text-gray-600 dark:text-gray-400">{message}</p>
      </div>
      <div className="mt-6 flex justify-end space-x-3">
        {/* Cancel Button */}
        <Button onClick={onClose} className={cancelClasses}>
          {cancelText}
        </Button>
        {/* Confirm Button */}
        <Button onClick={onConfirm} className={confirmClasses}>
          {confirmText}
        </Button>
      </div>
    </CustomPopover>
  );
}
